module.exports = __webpack_public_path__ + "img/avatar-w.0858cf46.png";